import Controller from '@ember/controller';

export default class RedeemInvitationController extends Controller {
  queryParams = ['token'];

  get invitationToken() {
    return this.token;
  }
}
